<template>
    <div class="user-select">
        <el-tag v-for="user in selectedUsers" :key="user.name" closable @close="deleteUser(user)" effect="plain">
            {{user.name}}
        </el-tag>
        <el-button @click="showDialog" size="mini">选择用户</el-button>
        <el-dialog
                title="选择用户"
                :visible.sync="dialogVisible"
                width="550px" append-to-body>
            <el-form inline size="mini">
                <el-form-item label="用户名">
                    <el-input v-model="keywordInput" style="width: 100px"></el-input>
                </el-form-item>
                <el-form-item label="用户组">
                    <user-group-select v-model="userGroupIdInput" value-type="id" clearable/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <div v-if="users">
                <el-table
                        :data="users.content"
                        style="width: 100%"
                        :row-class-name="tableRowClassName">
                    <el-table-column
                            prop="id"
                            label="用户ID"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="用户名">
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button v-if="isSelected(scope.row)" type="text" size="small"
                                       @click="deleteUser(scope.row)">取消选择
                            </el-button>
                            <el-button v-else type="text" size="small"
                                       @click="addUser(scope.row)">选择
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        layout="prev, pager, next" background
                        :total="users.totalElements" :current-page="users.number+1"
                        @current-change="fetchUsers"
                        style="width: fit-content;margin: 10px auto 0;">
                </el-pagination>
            </div>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="dialogVisible = false">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import userService from '../../service/user'

    export default {
        name: "UserSelect",
        props: {
            value: [Object, String, Array],
            valueType: {
                type: String,
                default: 'name',
                validator: function (value) {
                    return ['name', 'object'].indexOf(value) !== -1
                }
            },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                userGroupIdInput: null,
                userGroupId: null,
                keywordInput: null,
                keyword: null,
                users: null,
                dialogVisible: false
            }
        },
        computed: {
            selectedUsers() {
                if (!this.value) {
                    return []
                }
                let selectedUsers = []
                if (this.valueType === 'object') {
                    if (Array.isArray(this.value)) {
                        selectedUsers = this.value
                    } else {
                        selectedUsers = [this.value]
                    }
                } else {
                    if (Array.isArray(this.value)) {
                        selectedUsers = this.value.map(name => {
                            return {name}
                        })
                    } else {
                        selectedUsers = [{name: this.value}]
                    }
                }
                return selectedUsers
            }
        },
        methods: {
            search() {
                this.keyword = this.keywordInput
                this.userGroupId = this.userGroupIdInput
                this.fetchUsers()
            },
            fetchUsers(page) {
                userService.listVisibleUsers({
                    nameLike: this.keyword,
                    userGroupId: this.userGroupId,
                    page: page - 1,
                    size: 10
                }).then(response => this.users = response.data)
            },
            deleteUser(user) {
                const newValue = [...this.selectedUsers]
                newValue.splice(newValue.findIndex(item => item.name === user.name), 1)
                this.onInput(newValue)
            },
            addUser(user) {
                if (!this.multiple) {
                    this.onInput([user])
                    return
                }
                const newValue = [...this.selectedUsers]
                newValue.push(user)
                this.onInput(newValue)
            },
            onInput(users) {
                if (this.multiple) {
                    if (this.valueType === 'object') {
                        this.$emit('input', users)
                    } else {
                        this.$emit('input', users.map(user => user[this.valueType]))
                    }
                } else {
                    if (this.valueType === 'object') {
                        this.$emit('input', users.length === 0 ? null : users[0])
                    } else {
                        this.$emit('input', users.length === 0 ? null : users[0][this.valueType])
                    }
                }
            },
            isSelected(row) {
                for (const user of this.selectedUsers) {
                    if (user.name === row.name) {
                        return true
                    }
                }
                return false
            },
            tableRowClassName({row}) {
                for (const user of this.selectedUsers) {
                    if (user.name === row.name) {
                        return 'selected-row'
                    }
                }
                return this.isSelected(row) ? 'selected-row' : ''
            },
            showDialog(){
                if (!this.users) {
                    this.search()
                }
                this.dialogVisible = true
            }
        }
    }
</script>
<style scoped>
    .user-select {
        display: inline-block;
    }

    .el-table >>> .selected-row {
        background: #f0f9eb;
    }
    .el-tag{
        margin-right: 5px;
    }
</style>
